var _rect, _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualFilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 89,
    viewBox: "0 0 62 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 61,
    height: 88,
    rx: 4.5,
    fill: "#FDFDFE",
    stroke: "#255986"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9905_29116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 28.8339V33H35.1661L47.4533 20.7128L43.2872 16.5467L31 28.8339ZM50.675 17.491C51.1083 17.0578 51.1083 16.3579 50.675 15.9246L48.0754 13.325C47.6421 12.8917 46.9422 12.8917 46.509 13.325L44.4759 15.358L48.642 19.5241L50.675 17.491Z",
    fill: "#255986"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 27H25",
    stroke: "#255986",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 41H49",
    stroke: "#255986",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 55H49",
    stroke: "#255986",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 69H49",
    stroke: "#255986",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9905_29116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(27 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualFilling);
export default __webpack_public_path__ + "static/media/manual-filling.8358ff75cd812495a337bbfb802fe9e3.svg";
export { ForwardRef as ReactComponent };